import { Icon } from './Icon';

export function EmptyState({ title, copy }: { title: string; copy?: string }) {
  return (
    <div className="empty-state">
      <Icon name="leaf" size={26} />
      <strong>{title}</strong>
      {copy}
    </div>
  );
}
